import request from '@utils/request.js'
import { method } from 'lodash'


export const getResourcePageApi = (params) => request({
    url: '/train/rest/semi_file/get_resource_page/' + `${params.pageIndex}/` + `${params.pageSize}` + '?userId=' + `${params.userId}` + '&name=' + `${params.name}` + '&pid=' + `${params.pid}`,
    method: 'get',
})

export const getResourceListApi = (params) => request({
    url: '/train/rest/semi_file/get_resource_list_user/' + `${params.userId}/`,
    method: 'get',
});



export const addSemiResourceApi = (data) => request({
    url: '/train/rest/semi_file/add_resource/',
    method: 'post',
    data
})

export const updateSemiResourceApi = (data) => request({
    url: '/train/rest/semi_file/update_resource/',
    method: 'post',
    data
})


export const getSemiResourceApi = (params) => request({
    url: '/train/rest/semi_file/get_resource/' + `${params.id}`,
    method: 'get',
    params
})


export const delSemiResourceApi = (data) => request({
    url: '/train/rest/semi_file/del_resource/',
    method: 'post',
    data
})


export const getSemiResourceChildApi = (params) => request({
    url: '/train/rest/semi_file/get_resource_child_paths/' + `${params.pid}`,
    method: 'get',
});


export const getFilePageApi = (params) => request({
    url: '/train/rest/semi_file/get_file_page/' + `${params.pageIndex}/` + `${params.pageSize}`,
    method: 'get',
    params
})


export const removeFileApi = (data) => request({
    url: '/train/rest/semi_file/remove_file/',
    method: 'post',
    data
})

export const removeFilesApi = (data) => request({
    url: '/train/rest/semi_file/remove_files/',
    method: 'post',
    data
})


export const clearAllFilesApi = (data) => request({
    url: '/train/rest/semi_file/clear_all_files/',
    method: 'post',
    data
})


export const getMarkImageInfoApi = (params) => request({
    url: '/train/rest/semi_file/get_semi_file/' + `${params.pageIndex}/` + `${params.pageSize}`,
    method: 'get',
    params
})

/********** 任务管理 ********/


export const getTaskPageApi = (params) => request({
    url: '/train/rest/semi_task/get_page/' + `${params.pageIndex}/` + `${params.pageSize}` + '?userId=' + `${params.userId}` + '&status=' + `${params.status}`,
    method: 'get',
});

export const getTaskApi = (params) => request({
    url: '/train/rest/semi_task/get/' + `${params.id}/`,
    method: 'get',
});

export const addTask = (data) => request({
    url: '/train/rest/semi_task/add',
    method: 'post',
    data
});

export const updateTask = (data) => request({
    url: '/train/rest/semi_task/update',
    method: 'post',
    data
});

export const removeTask = (data) => request({
    url: '/train/rest/semi_task/remove',
    method: 'post',
    data
});

export const startTastTrain = (data) => request({
    url: '/train/rest/semi_task/start_train',
    method: 'post',
    data
});

export const getTaskListStatus = (data) => request({
    url: '/train/rest/semi_task/get_list_status',
    method: 'post',
    data
});

export const getTaskBreakError = (params) => request({
    url: '/train/rest/semi_task/get_break_error/' + `${params.id}`,
    method: 'get',
});
export const getTransBreakError = (params) => request({
    url: '/train/rest/task/get_break_error/' + `${params.id}`,
    method: 'get',
});
export const getLastLogList = (params) => request({
    url: '/train/rest/semi_task/get_last_log_list/' + `${params.id}`,
    method: 'get',
});

export const getNextLog = (params) => request({
    url: '/train/rest/semi_task/get_next_log/' + `${params.id}/` + `${params.logId}`,
    method: 'get',
});


export function getAllModelList() {
    return request({
        url: '/train/rest/network_model/get_list',
        method: 'get',
    })
}

export const setConvert = (taskId) => request({
    url: '/train/rest/task/set_convert/' + `${taskId}`,
    method: 'get',
});